export default {
  logisticscompany: {
    LogisticsCompanyName: '物流公司名称',
    Mobile: '手机',
    Address: '地址',
    LinkMan: '联系人',
    Website: '网址',
    AddLogisticsCompany: '新增物流公司',
    EditLogisticsCompany: '修改物流公司信息',
    LogisticsCompanyCanNotBeEmpty: '物流公司名称不能为空',
    LinkManCanNotBeEmpty: '联系人不能为空',
    AddressCanNotBeEmpty: '地址不能为空',
    WebsiteCanNotBeEmpty: '网址不能为空',
    TelCanNotBeEmpty: '电话不能为空',
    PleaseEnterCorrectWebsite: '请输入正确的网址',
    PleaseEnterCorrectTel: '请输入正确的电话号码'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/logisticscompany.js